<template>
  <div class="loading-screen" v-show="this.$store.state.isLoading">
    <div class="mx-auto my-auto text-center text-white">
      <i class="fa fa-spinner fa-5x spinner" aria-hidden="true"></i>
      <p class="mb-0">Loading</p>
    </div>
  </div>
</template>

<script>
export default{
  name:"LoadingScreen",
}
</script>
